export default __webpack_public_path__ + "static/media/banner_about.fce6fc3e.png";